export async function RouterPermissionMiddleware({ next, to }) {
    // review permission from path
    try {
        let pathMatch = to.matched[to.matched.length - 1].path;
        if(pathMatch === "") {
            pathMatch = to.path;
        }
        const {data} = await axios.post(`/api/backoffice/security/route/by-path`, {
            path: pathMatch
        })

        if(data.has_permission === true) {
            return next()
        } else {
            console.error("Ruta bloqueada por falta de permisos")
            return next({name: "notAuth"});
        }
    } catch (e) {
        let createNewRouteUri = `${window.location.origin}/security/route/create?path=${to.path}`;
        console.info(
          `La ruta ejecutada no existe en la colección de la base de datos.
          \n Para agregarla sigue el siguiente enlace.\n ${createNewRouteUri}`
        )

        // return next({ name: "notAuth" });
    }
}
